import React from 'react';
import './About.css';

function About() {
  return (
    <div className="about-container">
      {/* Left Side: My Story */}
      <div className="about-left">
        <h1>My Story</h1>
        <p>
          My coding journey began long before I ever wrote my first line of code. Growing up, I dreamed of becoming a professional footballer. The thrill of scoring a goal filled me with joy, and I loved training with my teammates, pushing myself to improve every week.
        </p>
        <p>
          By the time I turned 16, I realized that playing professional football wasn’t a feasible path. Around the same time, I stumbled upon a coding video on YouTube. I remember thinking, <i>“Wait, so I can just tell my computer to do something, and it will actually do it?”</i>
        </p>
        <p>
          That curiosity led me into programming. I began self-learning the basics—variables, loops, and functions—while still in high school. Soon, I built small projects like web scrapers and simple websites.
        </p>
        <p>
          In this new journey, the athlete in me was reborn. Completing a working project gave (and still gives) me the same joy as scoring a goal. I see learning new skills as training as a software athlete—there’s always something to improve on, and I love that because I get to play (code) every day!
        </p>
      </div>

      {/* Right Side: Tech Stack */}
      <div className="about-right">
        <h1>Tech Stack</h1>

        {/* Languages */}
        <div className="tech-category">
          <h2>Languages</h2>
          <div className="tech-items">
            <span>Python</span>
            <span>Java</span>
            <span>C</span>
            <span>Kotlin</span>
            <span>SQL</span>
            <span>JavaScript</span>
          </div>
        </div>

        {/* Web Development */}
        <div className="tech-category">
          <h2>Web Development</h2>
          <div className="tech-items">
            <span>Spring Boot</span>
            <span>React</span>
            <span>PostgreSQL</span>
            <span>Flask</span>
            <span>Django</span>
          </div>
        </div>

        {/* AI/ML */}
        <div className="tech-category">
          <h2>AI/ML</h2>
          <div className="tech-items">
            <span>TensorFlow</span>
            <span>PyTorch</span>
            <span>Scikit-Learn</span>
            <span>NumPy</span>
            <span>Pandas</span>
          </div>
        </div>

        {/* Tools */}
        <div className="tech-category">
          <h2>Tools</h2>
          <div className="tech-items">
            <span>Git</span>
            <span>Postman</span>
            <span>AWS EB</span>
            <span>Docker</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
